import script from "./CameraPhoto.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraPhoto.vue?vue&type=script&setup=true&lang=js"

import "./CameraPhoto.vue?vue&type=style&index=0&id=516b8db0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-516b8db0"]])

export default __exports__